import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable } from 'rxjs';

@Component({
  selector: 'iho-ecolodge-faq',
  templateUrl: './ecolodge-faq.component.html',
  styleUrls: ['./ecolodge-faq.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, MatExpansionModule, MatIconModule],
  animations: [
    trigger('expandAccordionPanel', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('500ms ease-in-out')),
    ]),
  ],
})
export class EcolodgeFaqComponent {
  ecolodgeFaq = [
    {
      title: '	چگونه می‌توانم اقامتگاه مورد نظرم را رزرو کنم؟',
      description:
        ' با جستجوی مقصد و انتخاب اقامتگاه مورد نظر، مراحل رزرو را با چند کلیک ساده طی کرده و به راحتی رزرو خود را انجام دهید. چنانچه نام اقامتگاه مورد نظرتان را از قبل می‌دانید، در باکس بالای صفحه وارد کنید؛ در غیر این صورت با وارد کردن نام شهر مقصد، اقامتگا‌های آن شهر اعم از اقامتگاه بومگردی، ویلا، خانه روستایی و ... را مشاهده خواهید کرد و از بین گزینه‌های پیش رو می‌توانید اقامتگاه مورد دلخواهتان را رزرو کنید. ',
    },
    {
      title: 'امکانات اقامتگاه‌ شامل چه مواردی می‌شود؟',
      description: `هر اقامتگاه امکانات خاص خود را دارد. به عنوان مثال: صبحانه، استخر، جکوزی، میز بیلیارد و تجهیزات آشپزی از جمله امکانات اقامتگاه‌‌ها و ویلاهای ایران هتل آنلاین هستند که در صفحه هر اقامتگاه در بخش امکانات قابل مشاهده است.
چنانچه اقامتگاه یا ویلا با امکانات خاصی را مد نظر دارید، می‌توانید با اعمال فیلتر مورد نظر در سایت، فقط اقامتگاه‌های با امکانات دلخواهتان را مشاهده کرده و بهترین آن را رزرو کنید. 
`,
    },
    {
      title: 'آیا امکان کنسلی رزرو وجود دارد؟ ',
      description: `بله، امکان کنسل کردن هر اقامتگاه فراهم است. قوانین دقیق کنسلی در هنگام رزرو و در صفحه اقامتگاه به صورت مجزا مشخص شده‌اند و به سه صورت سخت گیرانه، متعادل و سهل گیرانه می‌باشد. تفاوت کنسلی در هر مدل را می‌توانید اینجا بخوانید. لازم به ذکر است که کارمزد کنسلی ایران هتل آنلاین برای کنسلی اقامتگاه‌ها و ویلا از مبلغ مرجوعه به میهمان کسر خواهد شد..
`,
    },
    {
      title: 'چگونه می‌توانم با میزبان اقامتگاه ارتباط برقرار کنم؟ ',
      description: `پس از رزرو، اطلاعات تماس میزبان برای شما ارسال می‌شود و می‌توانید برای هماهنگی‌های بیشتر با او تماس بگیرید. سایر اطلاعات ضروری از جمله لوکیشن، آدرس دقیق و ساعت ورود و خروج به اقامتگاه‌های بوم گردی و یا ویلا در ووچر شما قابل مشاهده است. `,
    },
    {
      title: 'چگونه می‌توانم ویلا و اقامتگاهی متناسب با نیازهایم پیدا کنم؟ ',
      description: `با استفاده از فیلترهای سایت ایران هتل آنلاین مانند: امکانات، نوع اتاق، ظرفیت و قیمت می‌توانید بهترین گزینه را مطابق با سلیقه‌ و نیاز خود انتخاب کنید. با اعمال هر یک از فیلترهای اعلام شده، در کوتاه‌ترین زمان ممکن اقامتگاه خود را انتخاب و رزرو نمایید. `,
    },
    {
      title: 'آیا می‌توانم حیوان خانگی‌ام را همراه داشته باشم؟',
      description: `این موضوع بستگی به قوانین اقامتگاه دارد. در صفحه هر ویلا و یا اقامتگاه ذکر شده است که آیا پذیرش حیوانات خانگی امکان‌پذیر است یا خیر. با اعمال فیلتر "مجاز بودن حیوان خانگی" می‌توانید اقامتگاه‌های دلخواهتان با این مجوز به خصوص را انتخاب کنید`,
    },
    {
      title: 'آیا امکان تغییر تاریخ رزرو وجود دارد؟',
      description: `بله، بسته به قوانین اقامتگاه و زمان تغییر، ممکن است بتوانید تاریخ رزرو خود را تغییر دهید. برای جزئیات بیشتر، به بخش «شرایط کنسلی» در صفحه هر اقامتگاه مراجعه کنید.`,
    },
    {
      title: 'در صورت بروز مشکل در اقامتگاه و یا ویلا چه کاری باید انجام دهم؟ ',
      description: `در صورت بروز هرگونه مشکل، می‌توانید از طریق پشتیبانی آنلاین سایت با ما تماس بگیرید. ما در اسرع وقت مشکل را پیگیری خواهیم کرد. `,
    },
    {
      title: 'چطور می‌تونم به عنوان میزبان در ایران هتل آنلاین ثبت‌نام کنم؟',
      description: `برای اینکه بتوانید عضوی از اقامتگاه‌های سایت ایران هتل آنلاین باشید کافی است تا وارد <a target="_blank" class="text-blue-500" href="https://ihotel.iranhotelonline.com/account/register">صفحه میزبان شو</a> شوید. در این بخش با تکمیل فرم، پشتیبانان تیم با شما تماس گرفته و پس از صحت سنجی اطلاعات، اقامتگاه شما را برای مهمانان در معرض نمایش قرار خواهند داد.`,
    },
  ];
}
